export default __webpack_public_path__ + "static/media/iv-logo.1488254f.svg";